var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstOfTheYear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#FFEBF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9209_19261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9209_19261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8639 12.9152C42.717 11.8452 45.0002 11.8453 46.8534 12.9152L72.7844 27.8864C74.6376 28.9564 75.7792 30.9337 75.7792 33.0735V63.0161C75.7792 65.1559 74.6376 67.1332 72.7844 68.2032L46.8534 83.1744C45.0002 84.2444 42.717 84.2444 40.8639 83.1744L14.9329 68.2032C13.0797 67.1332 11.9381 65.1559 11.9381 63.0161V33.0735C11.9381 30.9337 13.0797 28.9564 14.9329 27.8864L40.8639 12.9152Z",
    fill: "#FFCDE5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.0601C72.2298 83.5012 12.5546 43.3756 6.58582 9.86812L-27.8162 57.6639L55.5728 117.685L107.846 45.0601Z",
    fill: "#F260A7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6846 18.2802L30.818 20.9082L32.904 26.6111L41.0492 23.3251L38.6846 18.2802Z",
    fill: "#FF6279"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.894 32.7618L29.8286 36.3048L31.9244 39.5494L36.4765 35.668L34.894 32.7618Z",
    fill: "#FF6279"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6632 28.9349L24.4907 25.5672L22.5503 28.9166L27.8028 31.6536L29.6632 28.9349Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.307 31.4915L41.1342 28.1238L39.1941 31.4736L44.4466 34.2103L46.307 31.4915Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9194 42.1939L26.077 40.1968L23.9468 43.3505L27.9506 44.8008L29.9194 42.1939Z",
    fill: "#43E9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0324 40.1709L38.1897 38.1735L36.0594 41.3274L40.0633 42.7778L42.0324 40.1709Z",
    fill: "#43E9C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.275 22.6677L27.2188 18.4168L24.944 18.0002L24.3749 22.1424L26.275 22.6677Z",
    fill: "#43E9C9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2529 48.6313L36.1967 44.3805L33.9218 43.9639L33.3524 48.1061L35.2529 48.6313Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0407 39.4857L24.3928 36.599L22.2025 35.9876L22.1887 38.8493L24.0407 39.4857Z",
    fill: "#FF6279"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.63 62.8312L35.7528 57.1825L32.0468 58.8031L34.3613 64.6408L37.63 62.8312Z",
    fill: "#FF6279"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0454 60.3629L25.6207 56.7613L23.5295 58.3418L26.1666 61.5649L28.0454 60.3629Z",
    fill: "#FF6279"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4584 56.5006L32.5713 52.6884L30.3339 51.347L28.6367 55.205L30.4584 56.5006Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0982 68.6067L31.211 64.7949L28.9737 63.4534L27.2767 67.3111L29.0982 68.6067Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7537 56.9401L22.992 54.1182L20.8794 52.6354L20.0037 55.5638L21.7537 56.9401Z",
    fill: "#43E9C9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.315 65.6762L24.553 62.8542L22.4408 61.3715L21.5647 64.2998L23.315 65.6762Z",
    fill: "#43E9C9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.51 53.9255L37.3204 54.5277L37.5505 52.8719L34.8188 52.5386L34.51 53.9255Z",
    fill: "#43E9C9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6274 60.9274L20.4378 61.5296L20.6679 59.8738L17.9362 59.5405L17.6274 60.9274Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4198 52.6294L25.323 52.829L25.6825 51.2306L23.8028 51.2754L23.4198 52.6294Z",
    fill: "#FF6279"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0722 45.3818L12.1068 44.3601L11.0171 45.9733L13.0649 46.7152L14.0722 45.3818Z",
    fill: "#4F4B66"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2679 44.3468L18.3024 43.3252L17.2128 44.9384L19.2606 45.6806L20.2679 44.3468Z",
    fill: "#4F4B66"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2078 35.3938L12.6905 33.2192L11.527 33.0061L11.2356 35.1249L12.2078 35.3938Z",
    fill: "#4F4B66"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8953 52.9248L10.5285 51.4812L9.44795 50.7227L9 52.2205L9.8953 52.9248Z",
    fill: "#4F4B66"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.694 57.3931L11.3275 55.9497L10.247 55.1912L9.79871 56.689L10.694 57.3931Z",
    fill: "#4F4B66"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4204 51.3829L17.858 51.6909L17.9757 50.8439L16.5782 50.6734L16.4204 51.3829Z",
    fill: "#4F4B66"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0745 30.9085L20.2313 33.2055L22.108 33.3754L21.6795 31.145L20.0745 30.9085Z",
    fill: "#FFD400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0865 25.8224L16.2434 28.1195L18.12 28.2893L17.6916 26.0589L16.0865 25.8224Z",
    fill: "#FFD400"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8183 37.6557L10.7885 38.32L11.2028 39.4813L13.0899 38.6718L12.8183 37.6557Z",
    fill: "#FFD400"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3832 30.8701L26.8773 31.0277L26.8016 32.3903L28.2584 32.0372L28.3832 30.8701Z",
    fill: "#FFD400"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6474 27.8832L30.1415 28.0408L30.0662 29.4034L31.5229 29.0506L31.6474 27.8832Z",
    fill: "#FFD400"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8116 25.7425L23.3365 24.2848L22.5815 24.6072L23.1494 25.9589L23.8116 25.7425Z",
    fill: "#FFD400"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3954 31.8583L38.4705 32.9574L39.3682 33.0388L39.1634 31.9717L38.3954 31.8583Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4868 29.4247L36.5619 30.5238L37.4599 30.6052L37.2549 29.5378L36.4868 29.4247Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9235 35.0869L33.9523 35.4047L34.1503 35.9604L35.0535 35.573L34.9235 35.0869Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.371 31.8399L41.6505 31.9152L41.6145 32.5673L42.3115 32.3985L42.371 31.8399Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9328 30.4111L43.2123 30.4864L43.176 31.1382L43.8733 30.9693L43.9328 30.4111Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1834 29.3867L39.956 28.6891L39.5947 28.8435L39.8666 29.4902L40.1834 29.3867Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1041 60.4445L14.1792 61.5437L15.0772 61.6251L14.8722 60.558L14.1041 60.4445Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1958 58.011L12.2709 59.1101L13.1686 59.1915L12.9639 58.1244L12.1958 58.011Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.632 63.6732L9.66077 63.9911L9.85911 64.5468L10.762 64.1594L10.632 63.6732Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0798 60.4262L17.3593 60.5015L17.323 61.1536L18.0203 60.9847L18.0798 60.4262Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6418 58.9975L18.921 59.0728L18.885 59.7249L19.582 59.5557L19.6418 58.9975Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8925 57.973L15.6651 57.2757L15.3038 57.4298L15.5754 58.0765L15.8925 57.973Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9877 70.6186L55.9863 67.3336L53.3444 61.8429L45.1086 65.8056L47.9877 70.6186Z",
    fill: "#FF6279"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7666 55.899L55.7663 51.944L53.3143 48.8978L48.878 53.1453L50.7666 55.899Z",
    fill: "#FF6279"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5383 59.256L62.2123 62.1616L63.9654 58.6661L58.2593 56.3943L56.5383 59.256Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9548 58.1375L44.6291 61.043L46.3819 57.5473L40.6758 55.2758L38.9548 58.1375Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M55.192 46.0975L59.3659 47.7543L61.333 44.4373L57.0352 43.3377L55.192 46.0975Z",
    fill: "#43E9C9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 49.1438L46.8855 50.8009L48.8527 47.4835L44.5548 46.384L42.7113 49.1438Z",
    fill: "#43E9C9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5859 65.1966L59.9466 69.503L62.3553 69.7226L62.6123 65.5563L60.5859 65.1966Z",
    fill: "#43E9C9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1003 40.1539L48.461 44.4603L50.8698 44.68L51.1271 40.5136L49.1003 40.1539Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5495 48.2871L61.4169 51.1868L63.7532 51.6073L63.5346 48.7614L61.5495 48.2871Z",
    fill: "#FF6279"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4624 26.2412L47.8819 31.696L51.6189 29.7682L48.7275 24.1629L45.4624 26.2412Z",
    fill: "#FF6279"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6696 27.8757L58.494 31.2487L60.5485 29.4988L57.5331 26.5202L55.6696 27.8757Z",
    fill: "#FF6279"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4647 31.9217L51.5693 35.8919L54.0142 37.0341L55.472 33.0539L53.4647 31.9217Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8994 19.7709L52.004 23.7408L54.4488 24.883L55.9063 20.9031L53.8994 19.7709Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5164 30.7404L61.4534 33.6515L63.7795 34.9449L64.4554 31.959L62.5164 30.7404Z",
    fill: "#43E9C9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1754 22.1898L59.1127 25.1009L61.4384 26.3943L62.1147 23.4084L60.1754 22.1898Z",
    fill: "#43E9C9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4445 34.8276L46.4615 34.4692L46.3561 36.1349L49.235 36.2327L49.4445 34.8276Z",
    fill: "#43E9C9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M66.499 26.4244L63.5161 26.066L63.4107 27.7317L66.2896 27.8295L66.499 26.4244Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1278 35.1683L59.1247 35.1325L58.8796 36.7522L60.8383 36.5469L61.1278 35.1683Z",
    fill: "#FF6279"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4761 41.5739L73.6111 42.4215L74.6173 40.7247L72.4191 40.1623L71.4761 41.5739Z",
    fill: "#4F4B66"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0924 43.1323L67.2274 43.9799L68.2337 42.2831L66.0354 41.7204L65.0924 43.1323Z",
    fill: "#4F4B66"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2354 51.3434L73.9085 53.5464L75.1405 53.6588L75.2722 51.5276L74.2354 51.3434Z",
    fill: "#4F4B66"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2224 33.7184L74.6789 35.2076L75.8687 35.8693L76.2144 34.3421L75.2224 33.7184Z",
    fill: "#4F4B66"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0253 29.3447L73.4814 30.8336L74.6712 31.4953L75.0172 29.968L74.0253 29.3447Z",
    fill: "#4F4B66"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5365 35.8092L67.0107 35.6259L66.9567 36.4779L68.4295 36.528L68.5365 35.8092Z",
    fill: "#4F4B66"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3881 56.4745L66.0373 54.2044L64.0644 54.196L64.6932 56.3766L66.3881 56.4745Z",
    fill: "#FFD400"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9655 61.1895L70.6147 58.9195L68.6418 58.9111L69.2706 61.0917L70.9655 61.1895Z",
    fill: "#FFD400"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M73.414 49.1471L75.479 48.3133L74.9519 47.1942L73.0478 48.1602L73.414 49.1471Z",
    fill: "#FFD400"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7169 57.223L59.2762 56.9375L59.2443 55.5765L57.7522 56.0521L57.7169 57.223Z",
    fill: "#FFD400"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5528 60.4711L56.1121 60.1856L56.0799 58.8247L54.5878 59.2999L54.5528 60.4711Z",
    fill: "#FFD400"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M62.907 61.9292L63.5217 63.3378L64.2836 62.9528L63.5807 61.6576L62.907 61.9292Z",
    fill: "#FFD400"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1844 57.0965L47.0166 56.0103L46.0728 56.0061L46.3734 57.0494L47.1844 57.0965Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M49.375 59.3524L49.2072 58.2661L48.263 58.262L48.564 59.3056L49.375 59.3524Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5463 53.5903L51.5344 53.1912L51.2825 52.6558L50.3711 53.1181L50.5463 53.5903Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0357 57.4545L43.7817 57.318L43.7662 56.6667L43.0524 56.8942L43.0357 57.4545Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5215 59.0084L42.2675 58.872L42.2523 58.2209L41.5382 58.4484L41.5215 59.0084Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5188 59.7064L45.8129 60.3805L46.1775 60.196L45.841 59.5764L45.5188 59.7064Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2169 26.603L70.0491 25.5168L69.1049 25.5126L69.4059 26.5559L70.2169 26.603Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M72.407 28.859L72.2391 27.7727L71.2953 27.7686L71.5959 28.8119L72.407 28.859Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5786 23.0967L74.5667 22.6977L74.3144 22.1623L73.4033 22.6246L73.5786 23.0967Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0679 26.9608L66.8139 26.8244L66.7987 26.173L66.0845 26.4005L66.0679 26.9608Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5535 28.515L65.2998 28.3785L65.2843 27.7272L64.5705 27.955L64.5535 28.515Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5508 29.2129L68.8449 29.8866L69.2095 29.7025L68.8733 29.0829L68.5508 29.2129Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7133 49.7127L37.1925 48.151C37.4818 47.8457 37.9637 47.8328 38.2693 48.1218L39.8307 49.601C40.3232 50.0676 40.0059 50.897 39.3275 50.9153L36.2869 50.9977C35.6085 51.016 35.2467 50.2053 35.7133 49.7127Z",
    fill: "#FF6279"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M39.147 49.1224C40.4377 49.6156 41.4354 49.9861 41.8574 51.4094C42.1617 52.436 42.014 52.8158 41.2727 53.5854C40.9272 53.9442 40.4929 54.2319 40.0855 54.5155C38.8125 55.4021 37.3908 56.0513 36.1178 56.9359C34.1274 58.3193 32.9285 60.452 33.5238 62.9156C34.0998 65.2988 36.0552 66.7913 38.2564 67.6031C39.5687 68.0869 40.9445 68.3643 42.2747 68.7913C43.4237 69.1601 46.3985 70.1458 46.5315 71.639C46.5897 72.2905 47.6147 72.2968 47.5561 71.639C47.3476 69.3014 43.9555 68.22 42.0739 67.6589C38.7812 66.6769 33.0173 65.213 34.575 60.3992C35.736 56.8112 40.5864 56.5385 42.6057 53.6253C44.4696 50.9365 41.6871 49.0014 39.4191 48.1347C38.8028 47.8989 38.5361 48.889 39.147 49.1224Z",
    fill: "#4E4D50"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3384 49.0144C37.382 49.1518 38.4246 49.1874 39.4751 49.1215C40.1299 49.0806 40.1346 48.0557 39.4751 48.0969C38.4246 48.1627 37.382 48.1272 36.3384 47.9898C35.6866 47.904 35.6929 48.9293 36.3384 49.0144Z",
    fill: "#4E4D50"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M51.046 37.75C52.6996 30.3685 48.0563 23.0442 40.6748 21.3906C33.2934 19.737 25.969 24.3803 24.3154 31.7618C22.6618 39.1432 27.3051 46.4676 34.6866 48.1212C42.0681 49.7748 49.3924 45.1315 51.046 37.75Z",
    fill: "#FF6279"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M27.949 41V38.57L31.765 34.574C32.077 34.238 32.323 33.938 32.503 33.674C32.695 33.398 32.833 33.146 32.917 32.918C33.013 32.678 33.061 32.438 33.061 32.198C33.061 31.742 32.911 31.4 32.611 31.172C32.311 30.944 31.879 30.83 31.315 30.83C30.835 30.83 30.343 30.92 29.839 31.1C29.347 31.268 28.855 31.544 28.363 31.928L27.337 29.516C27.889 29.084 28.561 28.742 29.353 28.49C30.145 28.238 30.955 28.112 31.783 28.112C32.767 28.112 33.589 28.256 34.249 28.544C34.921 28.832 35.431 29.252 35.779 29.804C36.127 30.344 36.301 31.016 36.301 31.82C36.301 32.204 36.259 32.582 36.175 32.954C36.091 33.314 35.959 33.674 35.779 34.034C35.599 34.382 35.365 34.742 35.077 35.114C34.789 35.486 34.441 35.87 34.033 36.266L31.117 39.146V38.318H36.769V41H27.949ZM42.9 41.198C41.856 41.198 40.974 40.94 40.254 40.424C39.534 39.908 38.988 39.164 38.616 38.192C38.244 37.208 38.058 36.014 38.058 34.61C38.058 33.194 38.244 32.006 38.616 31.046C38.988 30.074 39.534 29.342 40.254 28.85C40.974 28.358 41.856 28.112 42.9 28.112C43.944 28.112 44.826 28.358 45.546 28.85C46.266 29.342 46.812 30.074 47.184 31.046C47.556 32.006 47.742 33.188 47.742 34.592C47.742 35.996 47.556 37.19 47.184 38.174C46.812 39.158 46.266 39.908 45.546 40.424C44.826 40.94 43.944 41.198 42.9 41.198ZM42.9 38.57C43.476 38.57 43.902 38.258 44.178 37.634C44.466 36.998 44.61 35.984 44.61 34.592C44.61 33.212 44.466 32.228 44.178 31.64C43.902 31.04 43.476 30.74 42.9 30.74C42.324 30.74 41.892 31.04 41.604 31.64C41.328 32.228 41.19 33.218 41.19 34.61C41.19 35.99 41.328 36.998 41.604 37.634C41.892 38.258 42.324 38.57 42.9 38.57Z",
    fill: "#FFDADA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M44.7473 28.4633C45.2102 29.15 45.6129 29.8494 45.9574 30.5584C46.9245 30.2501 47.9275 30.0549 48.8627 30.0972C47.9734 27.6658 46.4207 25.5614 44.4237 24.002C43.3628 24.1048 42.3977 24.4091 41.551 24.7988C42.3761 25.5371 43.6109 26.7782 44.7473 28.4633Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M46.3073 31.3286C47.3701 33.8527 47.6897 36.4869 47.2447 39.1098C47.9744 38.9798 48.6052 38.8162 49.1493 38.6339C49.5367 37.303 49.7306 35.8916 49.691 34.4317C49.6585 33.2285 49.4666 32.0675 49.145 30.9638C48.269 30.8537 47.2787 31.0246 46.3073 31.3286Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0703 49.2516L50.6184 48.6676C50.921 48.5535 51.2592 48.7062 51.3733 49.0088L51.9572 50.5569C52.1415 51.0451 51.6433 51.5126 51.1677 51.2975L49.0357 50.3334C48.5601 50.1186 48.5818 49.4358 49.0703 49.2516Z",
    fill: "#FFD400"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51.626 49.9783C52.7248 51.1539 53.9236 52.5203 51.5262 53.8306C50.914 54.1652 50.0191 54.1076 49.338 54.1745C48.2242 54.2836 47.052 54.2523 45.9725 54.5912C44.4188 55.0794 43.298 56.3424 43.0646 57.9663C42.8178 59.6827 43.6193 61.2088 44.7603 62.425C45.9 63.6398 49.8564 66.0744 49.169 68.125C49.0074 68.6069 49.7683 68.8137 49.9289 68.3345C50.491 66.6578 48.5435 64.8184 47.4457 63.8071C46.6276 63.0535 45.7201 62.3764 45.0017 61.5201C43.5834 59.829 43.2119 57.0495 45.3443 55.7189C47.5412 54.3481 50.6469 55.6328 52.7909 54.1057C54.6526 52.7794 53.3666 50.6873 52.183 49.4212C51.8362 49.0498 51.2798 49.6081 51.626 49.9783Z",
    fill: "#4E4D50"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7098 48.9639C50.4142 49.4295 51.1574 49.8119 51.9386 50.1308C52.4079 50.3224 52.612 49.5605 52.1481 49.3709C51.4315 49.0783 50.7527 48.7098 50.1075 48.2831C49.6832 48.0028 49.2881 48.6849 49.7098 48.9639Z",
    fill: "#4E4D50"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9582 49.9918C62.7175 49.1627 66.7141 43.8217 65.8849 38.0625C65.0558 32.3033 59.7148 28.3067 53.9556 29.1358C48.1964 29.965 44.1997 35.3059 45.0289 41.0651C45.858 46.8244 51.199 50.821 56.9582 49.9918Z",
    fill: "#FFD400"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0715 44V42.11L51.0395 39.002C51.2821 38.7406 51.4735 38.5073 51.6135 38.302C51.7628 38.0873 51.8701 37.8913 51.9355 37.714C52.0101 37.5273 52.0475 37.3406 52.0475 37.154C52.0475 36.7993 51.9308 36.5333 51.6975 36.356C51.4641 36.1786 51.1281 36.09 50.6895 36.09C50.3161 36.09 49.9335 36.16 49.5415 36.3C49.1588 36.4306 48.7761 36.6453 48.3935 36.944L47.5955 35.068C48.0248 34.732 48.5475 34.466 49.1635 34.27C49.7795 34.074 50.4095 33.976 51.0535 33.976C51.8188 33.976 52.4581 34.088 52.9715 34.312C53.4941 34.536 53.8908 34.8626 54.1615 35.292C54.4321 35.712 54.5675 36.2346 54.5675 36.86C54.5675 37.1586 54.5348 37.4526 54.4695 37.742C54.4041 38.022 54.3015 38.302 54.1615 38.582C54.0215 38.8526 53.8395 39.1326 53.6155 39.422C53.3915 39.7113 53.1208 40.01 52.8035 40.318L50.5355 42.558V41.914H54.9315V44H48.0715ZM59.63 44.154C59.1913 44.154 58.7527 44.1073 58.314 44.014C57.8847 43.93 57.4833 43.8086 57.11 43.65C56.7367 43.4913 56.424 43.3093 56.172 43.104L56.956 41.186C57.3667 41.466 57.7913 41.6806 58.23 41.83C58.678 41.97 59.126 42.04 59.574 42.04C60.05 42.04 60.4187 41.9373 60.68 41.732C60.9413 41.5266 61.072 41.2373 61.072 40.864C61.072 40.4906 60.946 40.1966 60.694 39.982C60.442 39.7673 60.106 39.66 59.686 39.66C59.3687 39.66 59.0747 39.716 58.804 39.828C58.5427 39.9306 58.2953 40.0893 58.062 40.304H56.452V34.13H62.892V36.216H58.874V38.414H58.286C58.51 38.1526 58.7993 37.9566 59.154 37.826C59.518 37.686 59.9193 37.616 60.358 37.616C60.9833 37.616 61.534 37.7513 62.01 38.022C62.486 38.2833 62.8547 38.652 63.116 39.128C63.3867 39.604 63.522 40.1593 63.522 40.794C63.522 41.466 63.3633 42.0586 63.046 42.572C62.738 43.076 62.29 43.468 61.702 43.748C61.1233 44.0186 60.4327 44.154 59.63 44.154Z",
    fill: "#FF6279"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M62.4567 37.5796C62.5465 38.2102 62.5904 38.8294 62.5907 39.436C63.3636 39.5474 64.1232 39.7493 64.756 40.0921C64.9572 38.1111 64.5891 36.1333 63.7308 34.3837C62.9619 34.0984 62.192 33.985 61.4753 33.9704C61.7986 34.7585 62.2366 36.0319 62.4567 37.5796Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M62.5744 40.0865C62.4623 42.1902 61.7988 44.1204 60.6106 45.7862C61.159 45.9412 61.6508 46.0396 62.0885 46.0965C62.8035 45.3056 63.4117 44.3941 63.8747 43.3701C64.2561 42.5264 64.5132 41.6588 64.6612 40.7868C64.0915 40.4164 63.3486 40.2022 62.5744 40.0865Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.9804 82.9459C50.9086 82.9459 59.7677 81.9781 59.7677 80.7843C59.7677 79.5904 50.9086 78.6226 39.9804 78.6226C29.0522 78.6226 20.1931 79.5904 20.1931 80.7843C20.1931 81.9781 29.0522 82.9459 39.9804 82.9459Z",
    fill: "#4E4D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstOfTheYear);
export default __webpack_public_path__ + "static/media/first-of-the-year.0076ea2746d66046a7cde65b3fa575af.svg";
export { ForwardRef as ReactComponent };